export default "__VITE_ASSET__CXitq1zm__"